import React from 'react'

import WarningMessage from '../../../../../features/components/Form/WarningMessage'

const RightWrongDatesMessage = () => {
  return (
    <WarningMessage
      title="Sorry, your right end date is in the past"
      description="The dates of your digital right are not valid, please update them"
    />
  )
}

export default RightWrongDatesMessage
